<div class="title">
  შეიყვანე პირადი ინფორმაცია
</div>
<form [formGroup]="form">
  <div class="row">
    <div class="col-lg-6">
      <div class="form-group mt-4">
        <div class="d-flex">
          <label for="phone">სახელი</label>
        </div>
        <div class="mb-l ta-l pos-r" *ngIf="form.get('name'); let name;">
          <input name="name" class="form-control" placeholder="სახელი ლათინურად" oninput="this.value = this.value.toUpperCase()" formControlName="name" [ngClass]="{'has-error': !name.valid && submitted}"/>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="form-group mt-4">
        <div class="d-flex">
          <label for="phone">გვარი</label>
        </div>
        <div class="mb-l ta-l pos-r" *ngIf="form.get('surname'); let surname;">
          <input name="surname" class="form-control" placeholder="გვარი ლათინურად" oninput="this.value = this.value.toUpperCase()" formControlName="surname" [ngClass]="{'has-error': !surname.valid && submitted}"/>
        </div>
      </div>
    </div>
  </div>
  <div class="row align-items-center">
    <div class="col-lg-6">
      <div class="form-group mt-4">
        <div class="d-flex">
          <label for="phone">პირადი ნომერი</label>
        </div>
        <div class="mb-l ta-l pos-r" *ngIf="form.get('personalNumber'); let personalNumber;">
          <input name="personalNumber" (keypress)="numberOnly($event)" maxlength="11" class="form-control" placeholder="შეიყვანე პირადი ნომერი" formControlName="personalNumber" [ngClass]="{'has-error': !personalNumber.valid && submitted}"/>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="form-group mt-4">
        <label for="phone">დაბადების თარიღი</label>
        <div class="has-datepicker FormInput mb-l ta-l position-relative" *ngIf="form.get('birthDate'); let birthDate;">
          <input  placement="bottom left" formControlName="birthDate" type="text" class="form-control" name="birthDate" placeholder="დდ/თთ/წწწწ"  bsDatepicker #dp="bsDatepicker"
            autocomplete="off" [minDate]="minDate"
            [maxDate]="maxDate" [bsConfig]="{ adaptivePosition: true, startView: 'year', ignoreReadonly: true }" [readonly]="true" [ngClass]="{'has-error': !birthDate.valid && submitted}">
            <i class="fas fa-calendar-alt date-picker" (click)="dp.toggle()" [attr.aria-expanded]="dp.isOpen"></i>
          </div>

      </div>
    </div>
  </div>
  <p class="error-msg mt-4" *ngIf="age > 69">
    სამოგზაურო დაზღვევის შესაძენად, რისკის ინდივიდუალური შეფასების მიზნებისთვის, გთხოვთ, მოგვმართოთ 0322444999
  </p>
  <div class="sheet-buttons g g--spaceAround g--wrap g--nowrap@s g--alignEnd mt-5">
    <app-prev-btn></app-prev-btn>
    <app-next-btn (click)="onSubmit()"></app-next-btn>
  </div>
</form>
